import {Col, InputNumber} from "antd";
import styles from "./CohortTimeframe.module.scss";
import {CircleIcon} from "./CircleIcon";
import React from "react";
import {MAX_MONTHS, periodMonthsSet} from "./utils";
import ToolTip, { FOLLOWUP_PERIOD } from "../common/ToolTip";

export type FollowUpPeriodInputProps = {
    readOnly: boolean
    queryId: number
    followUpMonths: number
    setFollowUpMonths: (queryId: number, value: number | string | undefined) => void
    testId: string
}

export type FollowUpPeriodProps = {
    followUpMonths: number
}

export const FollowUpPeriodInput = ({readOnly, queryId, followUpMonths, setFollowUpMonths, testId}: FollowUpPeriodInputProps) => {
    if (readOnly && followUpMonths < 1) {
        return null
    }

    return <div className={styles.followUpPeriodUpperContainer} data-testid={testId}>
        <div >
            {!periodMonthsSet(followUpMonths) ?
                <><span className={styles.followUpHighlight}>Follow-Up Period<ToolTip content={FOLLOWUP_PERIOD}/></span><br/></>
                : ''
            }
            <span>Months</span><br/>
            <span>
                <InputNumber
                    readOnly={readOnly}
                    className={styles.periodInput}
                    min={1} max={MAX_MONTHS}
                    value={followUpMonths}
                    onChange={(value) => setFollowUpMonths(queryId, value)}
                />
            </span>
        </div>
    </div>
}

export const FollowUpPeriod = ({followUpMonths}: FollowUpPeriodProps) => {
    if (!periodMonthsSet(followUpMonths)) {
        return null
    }

    return <Col flex={followUpMonths}>
        <div className={styles.followUpPeriodUpper}>
            <CircleIcon radius={3} className={styles.followUpPeriodEndCircle}/>
        </div>
        <div className={styles.followUpPeriodLower}>
            <span className={styles.followUpHighlight}>Follow-up Period<ToolTip content={FOLLOWUP_PERIOD}/></span><br/>
        </div>
    </Col>
}